import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  HideBrokenImage,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import MainNavigationPanel from "../ui/user/main-navigation-panel";
import MainFooterPanel from "../ui/user/main-footer-panel";
import { useNavigate } from "react-router-dom";
import "../../styles/products-page.css";

export const Products: FC = () => {
  const [state, dispatch] = useAppStateContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <h1>Products</h1>
                  <div id="productsTableOfContent">
                    <div
                      className="product"
                      onClick={() => {
                        navigate("/products/charsync");
                      }}
                    >
                      <img
                        className="productThumb"
                        src="assets/thumbs/products/charsync.png"
                        alt="Charsync"
                        onError={HideBrokenImage}
                      />
                      <div className="productHeading">
                        <span className="productName">Charsync</span>
                      </div>
                      <p>
                        Keeps the models appended to your federation file
                        synchronized with the latest versions in your Digital
                        Charcoal cloud projects.
                      </p>
                    </div>
                    <div
                      className="product"
                      onClick={() => {
                        navigate("/products/charvue");
                      }}
                    >
                      <img
                        className="productThumb"
                        src="assets/thumbs/products/ncrp.png"
                        alt="Charvue"
                        onError={HideBrokenImage}
                      />
                      <div className="productHeading">
                        <span className="productName">Charvue</span>
                      </div>
                      <p>
                        Create custom reports from your Navisworks models and
                        extract valuable data.
                      </p>
                    </div>
                    {/* no page to route to yet, so they are marked rather than
                        left looking like broken links */}
                    <div className="product productComingSoon">
                      <img
                        className="productThumb"
                        src="assets/thumbs/products/mousePlugin.jpg"
                        alt="MousePlugin"
                        onError={HideBrokenImage}
                      />
                      <div className="productHeading">
                        <span className="productName">Mouse</span>
                        <span className="productTag">Coming soon</span>
                      </div>
                      <p>
                        A pathfinding plugin for Grasshopper based on the Theta*
                        algorithm.
                      </p>
                    </div>
                    <div className="product productComingSoon">
                      <img
                        className="productThumb"
                        src="assets/thumbs/products/stackingProgramming.jpg"
                        alt="StackingProgramming"
                        onError={HideBrokenImage}
                      />
                      <div className="productHeading">
                        <span className="productName">Stacking Programming</span>
                        <span className="productTag">Coming soon</span>
                      </div>
                      <p>
                        A Windows application designed for stacking programming.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
